
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import { SummaryDepositModel } from '@/models/summary-deposit';
import { DepositModel } from '@/models/deposit';

import ListDeposit from './components/ListDeposit.vue';
import FilterBox from './components/FilterBox.vue';

import depositServices from '@/services/deposit-services';
import SummaryOrder from './components/SummaryOrder.vue';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListDeposit,
        FilterBox,
        Loading,
        Paging,
        SummaryOrder
    }
})
export default class MainDeposit extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
    
    private summaryOrder: SummaryDepositModel = new SummaryDepositModel();
    private listDeposit: DepositModel[] = [];
    private isLoading = false;
    private chinaAddress = '';

    zeroPad = (num, places) => String(num).padStart(places, '0');

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get lineType() {
        return APP_CONFIG.lineType;
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.customerInfo.ID);
        if(result && result.status === 200) {
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async getConfig() {
      const result = await commonService.getDetailChinaStore(this.customerInfo.ChinaStoreID);

      if (result && result.status === 200) {
        this.chinaAddress = `${result.data.data.Receiver}${this.zeroPad(this.customerInfo.ID, 3)} - ${result.data.data.Phone} - ${result.data.data.Address}${this.zeroPad(this.customerInfo.ID, 3)}`;
      }
    }

    private async created() {
        this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryDepositModel();
        this.getCustomersInfo();
        this.getConfig();
        const result = await depositServices.getDeposit(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListDeposit: DepositModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus11: result.data.summary.TotalStatus11 || 0,
                TotalStatus12: result.data.summary.TotalStatus12 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
                TotalAmountStoreVN: result.data.summary.TotalAmountStoreVN || 0,
                TotalLeftStoreVN: result.data.summary.TotalLeftStoreVN || 0,
                TotalExportedNotPay: result.data.summary.TotalExportedNotPay > 0 ? result.data.summary.TotalExportedNotPay : 0,
            };

            for (const item of result.data.data) {
                const deposit = new DepositModel();
                deposit.id = item.ID;
                deposit.depositCode = item.DepositCode;
                deposit.uId = item.UID;
                deposit.userName = item.Username;
                deposit.status = item.Status;
                deposit.extraOption = item.ExtraOption;
                deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                deposit.extraOptionDetail = DATA.EXTRA_OPTIONS.find(x => x.value === item.ExtraOption) || { value: 0, name: 'Đơn thường', color: '#3b4354' };
                if (item.FeeShipType === 1) {
                    deposit.orderVolume = item.OrderWeight;
                } else {
                    deposit.orderWeight = item.OrderWeight;
                }
                deposit.feeShipCN = item.FeeShipCN;
                deposit.totalPriceVND = item.TotalPriceVND;
                deposit.createdDate = item.CreatedDate;
                deposit.payStatus = item.PayStatus;
                deposit.payment = item.Payment;
                deposit.productName = item.ProductName;
                deposit.numberOfPack = item.NumberOfPack;

                tmpListDeposit.push(deposit);
            }
            this.listDeposit = tmpListDeposit;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        // paramsFilter.filters.push({
        //     column: 'LineType',
        //     value: this.lineType,
        //     condition: 'equal'
        // });
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'DepositCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewDeposit() {
        const routeData = this.$router.resolve({ name: 'deposit-new' });
        window.open(routeData.href, '_blank');
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
